module.exports = __webpack_public_path__ + "img/blackRankIcon.1be7ab56.png";